import { Component, OnInit } from '@angular/core';
import { count } from 'console';
import { ToastrService } from 'ngx-toastr';
import { ApiService } from 'src/app/services/api.service';
import { GenericService } from 'src/app/services/generic.service';

@Component({
  selector: 'app-faces-register',
  templateUrl: './faces-register.component.html',
  styleUrls: ['./faces-register.component.css']
})
export class FacesRegisterComponent implements OnInit {
  file: any = [];
  imageUrls: any = [];
  name: any;

  allFacesPersons: any = [];
  allFacesImages: any = [];
  count: any = 0;
  isLoading: any = false
  isActionLoading: boolean = false;
  selectedDeletingImage: string = '';

  tableSize = 10;
  pageNumber = 1;
  totalRecords = 0;
  first: number = 0;

  selectedPersonId: any = '';
  selectedPersonName: any = '';
  selectedPersonImages: any = [];
  isViewLoading: boolean = false;
  imageBaseUrl: string = "https://objectdetection.anikinitek.com";

  constructor(
    private toastr: ToastrService,
    private generic_service: GenericService,
    private apiService: ApiService) { }

  ngOnInit(): void {
    this.getFacesPersons()
  }


  addImageBtn() {
    document.getElementById("add-Image-btn")?.click()
  }

  browseImage(event: any) {
    console.log(event)
    const image = event.target.files[0];

    const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];

    if (!validTypes.includes(image.type)) {
      this.toastr.error('Only .png, .jpg, and .jpeg files are allowed.')
      return;
    }

    this.file.push(image)
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.imageUrls.push(e.target.result);
    };
    reader.readAsDataURL(image);
    console.log(this.file)


  }

  uploadImage() {
    this.isActionLoading = true;
    this.apiService.uploadImage(this.name, this.file).subscribe(
      (res: any) => {
        console.log(res)
        this.toastr.success("success")
        this.file = []
        this.imageUrls = []
        this.name = ''
        this.isActionLoading = false;
        document.getElementById("closeModalButton2")?.click();
      },
      (error: any) => {
        console.log(error)
        this.file = []
        this.imageUrls = []
        this.name = ''
        this.toastr.error("error")
        this.isActionLoading = false;
      }
    )
  }

  closePopUp() {
    this.file = []
    this.imageUrls = []
    this.name = ''
  }

  removeImage(index: number) {
    this.file.splice(index, 1);
    this.imageUrls.splice(index, 1);
  }


  getFacesPersons() {
    this.isLoading = true
    this.apiService.facesPersons().subscribe(
      (res: any) => {
        console.log(res)
        this.allFacesPersons = res.persons
        this.count = res.persons.length
        this.totalRecords = res.persons.length
        this.isLoading = false
      },
      (error: any) => {
        this.isLoading = false
        console.log(error)
      }
    )
  }

  onTableDataChange(event: any): void {
    this.pageNumber = event.page + 1;
  }


  getFacesImages(person: any) {
    this.selectedPersonId = person.id;
    this.selectedPersonName = person.name;
    this.isViewLoading = true;
    this.selectedPersonImages = [];
    this.apiService.facesImages(person.id).subscribe(
      (res: any) => {
        console.log(res);
        this.selectedPersonImages = res.images || [];
        this.isViewLoading = false;
      },
      (error: any) => {
        console.log(error);
        this.isViewLoading = false;
      }
    );
  }

  prepareDeleteImage(filename: string) {
    this.selectedDeletingImage = filename;
  }

  deleteSingleImage() {
    const filename = this.selectedDeletingImage;
    if (!filename) return;
    const body: any = {
      "person_id": this.selectedPersonId,
      "filenames": [filename],
      "delete_all": false
    };

    this.isActionLoading = true;
    this.apiService.facesDeleteImages(body).subscribe(
      (res: any) => {
        this.isActionLoading = false;
        this.selectedDeletingImage = '';
        this.toastr.success("Image deleted successfully");
        document.getElementById("closeDeleteImageModalButton")?.click();
        this.fixModalScroll();
        this.getFacesImages({ id: this.selectedPersonId, name: this.selectedPersonName });
      },
      (error: any) => {
        this.isActionLoading = false;
        this.selectedDeletingImage = '';
        console.log(error);
        this.toastr.error("Error deleting image");
      }
    );
  }

  deletePersonProfile() {
    const body: any = {
      "person_id": this.selectedPersonId,
      "filenames": [],
      "delete_all": true
    };

    this.isActionLoading = true;
    this.apiService.facesDeleteImages(body).subscribe(
      (res: any) => {
        this.isActionLoading = false;
        this.toastr.success("Profile deleted successfully");
        document.getElementById("closeDeleteModalButton")?.click();
        this.getFacesPersons();
      },
      (error: any) => {
        this.isActionLoading = false;
        console.log(error);
        this.toastr.error("Error deleting profile");
      }
    );
  }

  setDeletePerson(person: any) {
    this.selectedPersonId = person.id;
    this.selectedPersonName = person.name;
  }

  updatePersonImages() {
    if (this.file.length === 0) {
      this.toastr.warning("Please browse images to add.");
      return;
    }

    this.isActionLoading = true;
    this.apiService.updateImage(this.selectedPersonId, this.selectedPersonName, this.file).subscribe(
      (res: any) => {
        this.isActionLoading = false;
        this.toastr.success("Images added successfully");
        this.closePopUp();
        this.getFacesImages({ id: this.selectedPersonId, name: this.selectedPersonName });
        this.getFacesPersons();
      },
      (error: any) => {
        this.isActionLoading = false;
        console.log(error);
        this.toastr.error("Error adding images");
      }
    )
  }

  fixModalScroll() {
    setTimeout(() => {
      if (document.querySelectorAll('.modal.show').length > 0 || document.querySelectorAll('.modal.in').length > 0) {
        document.body.classList.add('modal-open');
      }
    }, 500);
  }

}
